import request from "./request";

// 添加公司
export const addCompanyApi = (data) =>
  request({
    url: "/api/company/addCompany",
    method: "post",
    data,
  });
// 获取公司
export const searchCompanyApi = (data) =>
  request({
    url: "/api/company/searchCompany",
    method: "post",
    data,
  });

// 删除公司
export const deleteCompanyByIdApi = (data) =>
  request({
    url: "/api/company/deleteCompanyById",
    method: "post",
    data,
  });
// 编辑公司
export const editCompanyApi = (data) =>
  request({
    url: "/api/company/editCompany",
    method: "post",
    data,
  });
// 添加人员
export const addAdminUserApi = (data) =>
  request({
    url: "/api/admin_user/addAdminUser",
    method: "post",
    data,
  });
// 获取人员
export const searchAdminUserApi = (data) =>
  request({
    url: "/api/admin_user/searchAdminUser",
    method: "post",
    data,
  });
// 删除人员
export const deleteAdminUserByIdApi = (data) =>
  request({
    url: "/api/admin_user/deleteAdminUserById",
    method: "post",
    data,
  });
// 编辑人员
export const editAdminUserApi = (data) =>
  request({
    url: "/api/admin_user/editAdminUser",
    method: "post",
    data,
  });
// 获取角色
export const searchRoleApi = (data) =>
  request({
    url: "/api/role/searchRole",
    method: "post",
    data,
  });
// 获取权限
export const searchPremissApi = (data) =>
  request({
    url: "/api/premiss/searchPremiss",
    method: "post",
    data,
  });
// 添加权限
export const addPremissApi = (data) =>
  request({
    url: "/api/premiss/addPremiss",
    method: "post",
    data,
  });
// 删除权限
export const deletePremissByIdApi = (data) =>
  request({
    url: "/api/premiss/deletePremissById",
    method: "post",
    data,
  });
// 编辑权限
export const editPremissApi = (data) =>
  request({
    url: "/api/premiss/editPremiss",
    method: "post",
    data,
  });
// 添加角色
export const addRoleApi = (data) =>
  request({
    url: "/api/role/addRole",
    method: "post",
    data,
  });
// 删除角色
export const deleteRoleByIdApi = (data) =>
  request({
    url: "/api/role/deleteRoleById",
    method: "post",
    data,
  });
// 编辑角色
export const editRoleApi = (data) =>
  request({
    url: "/api/role/editRole",
    method: "post",
    data,
  });
// 登录
export const loginApi = (data) =>
  request({
    url: "/api/admin_user/login",
    method: "post",
    data,
  });
// 获取app用户
export const searchAppUserApi = (data) =>
  request({
    url: "/api/dian/search_user",
    method: "post",
    data,
  });
// 获取下级用户
export const searchNextAppUserApi = (data) =>
  request({
    url: "/api/dian/search_user_front",
    method: "post",
    data,
  });
// 添加任务
export const addTaskApi = (data) =>
  request({
    url: "/api/task/addTask",
    method: "post",
    data,
  });
// 编辑任务
export const editTaskApi = (data) =>
  request({
    url: "/api/task/editTask",
    method: "post",
    data,
  });
// 查询任务
export const searchTaskApi = (data) =>
  request({
    url: "/api/task/searchTask",
    method: "post",
    data,
  });
// 删除任务
export const deleteTaskByIdApi = (data) =>
  request({
    url: "/api/task/deleteTaskById",
    method: "post",
    data,
  });
// 添加数据
export const addTaskDataApi = (data) =>
  request({
    url: "/api/taskData/addTaskData",
    method: "post",
    data,
  });
// 批量导入
export const uploadBatchPhonesApi = (data) =>
  request({
    url: "/api/taskData/uploadBatchPhones",
    method: "post",
    data,
  });
// 查看任务数据
export const searchTaskDataApi = (data) =>
  request({
    url: "/api/taskData/searchTaskData",
    method: "post",
    data,
  });
// 删除任务数据
export const deleteTaskDataByIdApi = (data) =>
  request({
    url: "/api/taskData/deleteTaskDataById",
    method: "post",
    data,
  });

// 根据id获取任务详情
export const searchTaskByIdApi = (data) =>
  request({
    url: "/api/task/searchTaskById",
    method: "post",
    data,
  });
// 审核任务
export const auditDataApi = (data) =>
  request({
    url: "/api/taskData/auditData",
    method: "post",
    data,
  });
// 设置版本号
export const editVersionApi = (data) =>
  request({
    url: "/api/version/edit",
    method: "post",
    data,
  });
// 通过率
export const searchTaskBordApi = (data) =>
  request({
    url: "/api/taskBord/searchTaskBord",
    method: "post",
    data,
  });
// 通过率
export const startTaskApi = (data) =>
  request({
    url: "/api/task/startTask",
    method: "post",
    data,
  });
// 通过率
export const stopTaskApi = (data) =>
  request({
    url: "/api/task/stopTask",
    method: "post",
    data,
  });
// 首页数据
export const searchTaskDataStatisticsApi = (data) =>
  request({
    url: "/api/taskData/searchTaskDataStatistics",
    method: "post",
    data,
  });
// 提现看板
export const searchWithDrawApi = (data) =>
  request({
    url: "/api/balances/searchWithDraw",
    method: "post",
    data,
  });
// 查询代理人账户余额
export const searchMyAccountListApi = (data) =>
  request({
    url: "/api/account/searchMyAccountList",
    method: "post",
    data,
  });
// 查询代理人账户余额
export const searchBalancesApi = (data) =>
  request({
    url: "/api/balances/searchBalances",
    method: "post",
    data,
  });
// 查询所有任务数据总和
export const searchTaskStatisticsApi = (data) =>
  request({
    url: "/api/task/searchTaskStatistics",
    method: "post",
    data,
  });
// 导出已通过数据
export const exportTaskDataApi = (data) =>
  request({
    url: "/api/taskData/exportTaskData",
    method: "post",
    data,
    responseType: "blob",
  });
// 账号封禁
export const userBannedApi = (data) =>
  request({
    url: "/api/dian/userBanned",
    method: "post",
    data,
  });
// 查询审核历史
export const searchAuditHistoryApi = (data) =>
  request({
    url: "/api/taskData/searchAuditHistory",
    method: "post",
    data,
  });
// 切换审核任务
export const searchWaiAuditTaskDataApi = (data) =>
  request({
    url: "/api/taskData/searchWaiAuditTaskData",
    method: "post",
    data,
  });
// 切换审核任务
export const searchPrevAuditTaskDataApi = (data) =>
  request({
    url: "/api/taskData/searchPrevAuditTaskData",
    method: "post",
    data,
  });
// 添加常见问题
export const addQaApi = (data) =>
  request({
    url: "/api/qa/addQa",
    method: "post",
    data,
  });
// 查询常见问题
export const searchQaApi = (data) =>
  request({
    url: "/api/qa/searchQa",
    method: "post",
    data,
  });
// 删除常见问题
export const deleteQaByIdApi = (data) =>
  request({
    url: "/api/qa/deleteQaById",
    method: "post",
    data,
  });
// 编辑常见问题
export const editQaApi = (data) =>
  request({
    url: "/api/qa/editQa",
    method: "post",
    data,
  });
// 代理人员活跃度
export const searchTaskBordActivityLevelApi = (data) =>
  request({
    url: "/api/taskBord/searchTaskBordActivityLevel",
    method: "post",
    data,
  });
// 编辑代理人信息
export const editUserApi = (data) =>
  request({
    url: "/api/dian/user_edit",
    method: "post",
    data,
  });
// 推广员列表
export const searchCustomerStatisticsApi = (data) =>
  request({
    url: "/api/dian/searchCustomerStatistics",
    method: "post",

    data,
  });
// 导出数据
export const exportTaskDataAllApi = (data) =>
  request({
    url: "/api/taskData/exportTaskDataAll",
    method: "post",
    data,
    responseType: "blob",
  });
// 获取用户今日加微照片
export const searchUserTaskApi = (data) =>
  request({
    url: "/api/userTask/searchUserTask",
    method: "post",
    data,
  });
// 获取用户今日任务
export const searchUserTaskWaiAuditApi = (data) =>
  request({
    url: "/api/userTask/searchUserTaskWaiAudit",
    method: "post",
    data,
  });
// 获取今日任务待审核的数据
export const searchTaskDataWaitAuditApi = (data) =>
  request({
    url: "/api/taskData/searchTaskDataWaitAudit",
    method: "post",
    data,
  });
// 提交今日任务审核的数据
export const auditDataDayApi = (data) =>
  request({
    url: "/api/taskData/auditDataDay",
    method: "post",
    data,
  });
// 根据手机号查询数据
export const searchTaskDataByPhoneApi = (data) =>
  request({
    url: "/api/taskData/searchTaskDataByPhone",
    method: "post",
    data,
  });
